define('glu/controller',['require','backbone','marionette','./$','./util','./itemView','./http','./store','./appBus'],function(require) {
    'use strict';

    var Backbone = require('backbone'),
        Marionette = require('marionette'),
        $ = require('./$'),
        util = require('./util'),
        ItemView = require('./itemView'),
        http = require('./http'),
        store = require('./store'),
        appBus = require('./appBus');

    return Marionette.Controller.extend({
        constructor: function() {
            Marionette.Controller.prototype.constructor.apply(this, Array.prototype.slice.call(arguments));
        },

        appBus: appBus,

        getLoadingView: function() {
            if (this.loadingView) {
                return this.loadingView;
            }

            this.loadingView = ItemView.extend({
                className: 'glu-content-loading',
                template: function() {
                    return '<div class="loader"></div>';
                }
            });

            return this.loadingView;
        },

        showPage: function(title, view, options) {
            // TODO: Title is currently optional. This will be removed soon.
            if (typeof title !== 'string') {
                options = view;
                view = title;
                title = null;
            }

            options = options || {};

            var fragment = Backbone.history.fragment;

            // in case of reloading the page after session expiration
            // to prevent double binding of view events
            if (this.lastFragment === fragment && this.pendingPage) {
                this.pendingPage.close();
            }

            this.lastFragment = fragment;

            // Stop listening for any previous page to finish
            if (this.pendingPage) {
                this.stopListening(this, 'showPage:' + this.pendingPage.cid);
                this.pendingPage = null;
            }

            // If this page is to be shown immediately (the default action), then do so
            if (typeof options.immediate === 'undefined' || options.immediate) {
                return this.appBus.trigger('show:page', view, title, options);
            }

            // Show loading
            var Loading = this.getLoadingView();
            this.appBus.trigger('show:page', new Loading(), 'Loading', options);

            this.pendingPage = view;

            this.listenTo(this, 'showPage:' + this.pendingPage.cid, function() {
                this.appBus.trigger('show:page', this.pendingPage, title, options);
            }, this);

            return util.bind(function() {
                this.trigger('showPage:' + this.pendingPage.cid);
            }, this);
        },

        logout: function() {
            var self = this;
            http.del((this.brandMode ? '/admin-service' : '/payments-service') + '/api/security/logout', function() {
                store.unset('last404');

                // Unset flag to determine if session ended without manual interaction from the user
                store.unset('bt:loggedIn');
                store.unset('bt:userInfo');

                // Set URL back to root, and reload page to trigger login to be displayed
                self.appBus.trigger('router:navigate', self.brandMode ? '/brand' : '');
                window.location.reload();
            });
        }
    });
});

